import React, { FC } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import useHttpGet from "../../hooks/useHttpGet";
import { IResultResponse } from "../../models/response/result.model";
import { APIRoutes } from "../../http";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import {
  IInstrument,
  IInstrumentHistoricalData,
} from "../../models/instrument.model";
import CommonService from "../../services/common.service";
import { UIRoutes } from "../../router";
import { currencyFormat } from "../../services/constants";

const WinnersLosers: FC = () => {
  const indexId = useTypedSelector(({ ci }) => ci.indexId);

  const { fetchedData, loading } = useHttpGet<IResultResponse<IInstrument[]>>(
    `${APIRoutes.INSTRUMENT_FOR_INDEX}/${indexId}`,
    {
      dependencies: [indexId],
      condition: !!indexId,
      defaultValue: { result: [] as IInstrument[] },
    }
  );

  const columns = [
    {
      title: "#",
      dataIndex: "sortNumber",
      key: "id",
    },
    {
      title: "Asset",
      dataIndex: "name",
      key: "asset",
      render: (text: string, record: IInstrument) => (
        <div className="d-flex align-items-center">
          <span className={record?.image}></span>
          <Link
            to={`/${
              UIRoutes.VIEW_INSTRUMENT_BASE
            }/${CommonService.replaceSymbol(record?.name)}/${record?.id}`}
          >
            {text}
          </Link>
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "lastHistoricalData",
      key: "price",
      render: (text: IInstrumentHistoricalData) =>
        CommonService.toLocalNum(text?.adjClose, currencyFormat),
    },
    {
      title: "Market CAP",
      dataIndex: "lastHistoricalData",
      key: "marketCAP",
      render: (text: IInstrumentHistoricalData) =>
        CommonService.toLocalNum(text?.marketCap, currencyFormat),
    },
    {
      title: "24H Change",
      dataIndex: "lastHistoricalData",
      key: "change",
      render: (text: IInstrumentHistoricalData) => (
        <span className={CommonService.numberColor(text?.changePercent || 0)}>
          {`${text?.changePercent || 0} %`}
        </span>
      ),
    },
  ];

  return (
    <div>
      <h3 className="mt-1">TOP 5 WINNERS</h3>
      <Table
        size="small"
        columns={columns}
        dataSource={fetchedData?.result
          ?.sort(
            (a: IInstrument, b: IInstrument) =>
              b?.lastHistoricalData?.changePercent -
              a?.lastHistoricalData?.changePercent
          )
          .slice(0, 5)}
        pagination={false}
        loading={loading}
        rowKey={(record: IInstrument) => record.id}
      />

      <h3 className="mt-2">TOP 5 LOSERS</h3>
      <Table
        size="small"
        columns={columns}
        dataSource={fetchedData?.result
          ?.sort(
            (a: IInstrument, b: IInstrument) =>
              a?.lastHistoricalData?.changePercent -
              b?.lastHistoricalData?.changePercent
          )
          .slice(0, 5)}
        pagination={false}
        loading={loading}
        rowKey={(record: IInstrument) => record.id}
      />
    </div>
  );
};

export default WinnersLosers;
